/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EdiOutboundTrackingResponse } from "./EdiOutboundTrackingResponse";
import {
  EdiOutboundTrackingResponseFromJSON,
  EdiOutboundTrackingResponseFromJSONTyped,
  EdiOutboundTrackingResponseToJSON,
  EdiOutboundTrackingResponseToJSONTyped,
} from "./EdiOutboundTrackingResponse";

/**
 *
 * @export
 * @interface EdiOutboundTrackingPage
 */
export interface EdiOutboundTrackingPage {
  /**
   *
   * @type {Array<EdiOutboundTrackingResponse>}
   * @memberof EdiOutboundTrackingPage
   */
  rows: Array<EdiOutboundTrackingResponse>;
  /**
   *
   * @type {number}
   * @memberof EdiOutboundTrackingPage
   */
  totalCount: number;
}

/**
 * Check if a given object implements the EdiOutboundTrackingPage interface.
 */
export function instanceOfEdiOutboundTrackingPage(
  value: object,
): value is EdiOutboundTrackingPage {
  if (!("rows" in value) || value["rows"] === undefined) return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  return true;
}

export function EdiOutboundTrackingPageFromJSON(
  json: any,
): EdiOutboundTrackingPage {
  return EdiOutboundTrackingPageFromJSONTyped(json, false);
}

export function EdiOutboundTrackingPageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiOutboundTrackingPage {
  if (json == null) {
    return json;
  }
  return {
    rows: (json["rows"] as Array<any>).map(EdiOutboundTrackingResponseFromJSON),
    totalCount: json["totalCount"],
  };
}

export function EdiOutboundTrackingPageToJSON(
  json: any,
): EdiOutboundTrackingPage {
  return EdiOutboundTrackingPageToJSONTyped(json, false);
}

export function EdiOutboundTrackingPageToJSONTyped(
  value?: EdiOutboundTrackingPage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    rows: (value["rows"] as Array<any>).map(EdiOutboundTrackingResponseToJSON),
    totalCount: value["totalCount"],
  };
}
